/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Who signed in: the agent itself, or a workload that federation assigns to the agent.
 */
export const SubjectKind = {
  Agent: "agent",
  Workload: "workload",
} as const;
/**
 * Who signed in: the agent itself, or a workload that federation assigns to the agent.
 */
export type SubjectKind = OpenEnum<typeof SubjectKind>;

export type AgentSession = {
  authorizerUserId?: string | undefined;
  clientName?: string | undefined;
  createdAt: Date;
  expiresAt: Date;
  id: string;
  issuerId: string;
  issuerSlug: string;
  lastUsedAt?: Date | undefined;
  projectId?: string | undefined;
  refreshExpiresAt: Date;
  /**
   * Who signed in: the agent itself, or a workload that federation assigns to the agent.
   */
  subjectKind: SubjectKind;
  /**
   * The workload's subject as its platform issued it. Set only when subject_kind is workload.
   */
  workloadSubject?: string | undefined;
};

/** @internal */
export const SubjectKind$inboundSchema: z.ZodMiniType<SubjectKind, unknown> =
  openEnums.inboundSchema(SubjectKind);

/** @internal */
export const AgentSession$inboundSchema: z.ZodMiniType<AgentSession, unknown> =
  z.pipe(
    z.object({
      authorizer_user_id: z.optional(z.string()),
      client_name: z.optional(z.string()),
      created_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      expires_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      id: z.string(),
      issuer_id: z.string(),
      issuer_slug: z.string(),
      last_used_at: z.optional(
        z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
      ),
      project_id: z.optional(z.string()),
      refresh_expires_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      subject_kind: SubjectKind$inboundSchema,
      workload_subject: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        "authorizer_user_id": "authorizerUserId",
        "client_name": "clientName",
        "created_at": "createdAt",
        "expires_at": "expiresAt",
        "issuer_id": "issuerId",
        "issuer_slug": "issuerSlug",
        "last_used_at": "lastUsedAt",
        "project_id": "projectId",
        "refresh_expires_at": "refreshExpiresAt",
        "subject_kind": "subjectKind",
        "workload_subject": "workloadSubject",
      });
    }),
  );

export function agentSessionFromJSON(
  jsonString: string,
): SafeParseResult<AgentSession, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentSession$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentSession' from JSON`,
  );
}
